<template>
  <v-dialog
    v-model="dialog"
    scrollable
    @click:outside="dialog = !dialog"
  >
    <template #activator="{ props }">
      <v-btn
        class="mr-2"
        v-bind="props"
      >
        View Logs
      </v-btn>
    </template>
    <v-card :loading="formProcessing">
      <v-card-title>
        <span class="headline">
          Ticket Log
        </span>
      </v-card-title>

      <v-card-text>
        <v-data-table-server
          v-model:options="options"
          dense
          :headers="headers"
          :loading="loading"
          :items="items"
          :items-length="totalItems"
          class="elevation-1"
          :items-per-page-options="footerProps.itemsPerPageOptions"
          @update:options="updateTable"
        >
          <template #item.method="{ item }">
            {{ item.method.toUpperCase() }}
          </template>
          <template #item.actions="{ item }">
            <v-btn
              tile
              color="primary"
              small
              text
              @click="showJsonModal('JSON Payload', item.properties.request, false)"
            >
              <v-icon
                dark
                left
                class="mr-1"
              >
                mdi-eye
              </v-icon>
              PAYLOAD
            </v-btn>
            <v-btn
              tile
              color="teal"
              small
              text
              @click="showJsonModal('JSON Response', item.properties.response, true)"
            >
              <v-icon
                dark
                left
                class="mr-1"
              >
                mdi-eye
              </v-icon>
              RESPONSE
            </v-btn>
          </template>
        </v-data-table-server>
      </v-card-text>

      <v-card-actions>
        <v-spacer />

        <v-btn
          color="blue darken-1"
          text
          :disabled="formProcessing"
          @click="dialog = !dialog"
        >
          Close
        </v-btn>
      </v-card-actions>
      <JsonModal
        v-model="ticketLogJsonModal"
        :title="ticketLogJsonTitle"
        :json="ticketLogJson"
        @close-modal="closeJsonModal()"
        @click:outside="closeJsonModal()"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';

import dataTableMixin from '@/mixins/dataTableMixin.js';
import JsonModal from '@/components/JsonModal.vue';

export default {
  name: 'TicketLogModal',
  components: {
    JsonModal,
  },
  mixins: [
    dataTableMixin,
  ],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    editedItem: {
      type: Object,
      default() {
        return {
          id: null,
        };
      },
    },
  },
  data() {
    return {
      ticketLogJsonModal: false,
      ticketLogJsonTitle: '',
      ticketLogJson: {},
      id: null,
      loans: [],
      formProcessing: false,
      loading: false,
      dialog: false,
      headers: [
        { title: 'Context', value: 'properties.context.name' },
        { title: 'Description', value: 'description', width: 120 },
        { title: 'Endpoint', value: 'properties.endpoint', width: 120 },
        { title: 'Method', value: 'properties.method' },
        { title: 'Response', value: 'properties.status' },
        { title: 'Time', value: 'created_at' },
        { title: 'Actions', value: 'actions', sortable: false },
      ],
    };
  },

  watch: {
    editedItem() {
      this.id = this.editedItem.id;
    },
  },
  methods: {
    ...mapActions('notification', ['setNotification']),
    closeJsonModal() {
      this.ticketLogJsonModal = false;
      this.$nextTick(() => {
        this.ticketLogJson = {};
      });
    },
    showJsonModal(title, json, convert) {
      try {
        this.ticketLogJson = convert ? JSON.parse(json) : json;
        this.ticketLogJsonTitle = title;
        this.ticketLogJsonModal = true;
      } catch (e) {
        this.ticketLogJson = {};
      }
    },
    updateTable() {
      this.loading = true;

      return this.$axios
        .get('api/v1/support/ticket/activity', {
          params: {
            ticketId: this.$route.params.id,
            perPage: this.options.itemsPerPage,
            page: this.options.page,
            ...this.sortParams,
          },
        })
        .then((res) => {
          this.loading = false;
          this.items = res.data.data;
          this.totalItems = res.data.total;
        });
    },
  },
};
</script>
